export function removerCaracteresEspeciais(nomeImagem) {
    let nomeLimpo = "";
    nomeLimpo = nomeImagem.replace(/[^a-zA-Z0-9_' ']/g, "_");

    return nomeLimpo;
}
